const POLE_SLIDE_DURATION = 1;
const FLAG_ROTATE_DURATION = 1.5;

const els = {
    $heading: () => $('[data-heading-with-year-flag]'),
    $pole: ($heading) => $heading.find('[data-pole]'),
    $flag: ($heading) => $heading.find('[data-flag]'),
};

const initializeHeading = ($heading) => {

    const $pole = els.$pole($heading);
    const $flag = els.$flag($heading);

    gsap.set($pole, { xPercent: -105 });

    gsap.set($pole, { visibility: 'visible' });

    gsap.set(
        $flag,
        {
            rotateX: -90,
            transformOrigin: 'top',
            transformPerspective: 800,
        }
    );

    const timeline = gsap.timeline({
        scrollTrigger: {
            trigger: $heading,
            start: 'center 75%',
        },
    });

    timeline.to(
        $pole,
        {
            xPercent: 0,
            ease: 'power3.out',
            duration: POLE_SLIDE_DURATION,
        }
    );

    timeline.to(
        $flag,
        {
            rotateX: 0,
            ease: 'elastic.out',
            duration: FLAG_ROTATE_DURATION,
        }
    );
};

const initialize = () => {

    els.$heading().each((index, element) => {
        initializeHeading($(element));
    });
};

export default {
    initialize,
};

